"use client";

import { createContext, useContext } from "react";
import type { FirebaseApp } from "firebase/app";
import type { Auth } from "firebase/auth";
import type { Firestore } from "firebase/firestore";

import { useFirebaseClient } from './client-provider';

// This file can be simplified or deprecated, but we'll keep its hooks for compatibility
// and point them to the new unified provider.

export const useFirebase = () => {
    const { app, auth, firestore } = useFirebaseClient();
    if (!app || !auth || !firestore) {
        throw new Error("Firebase not initialized. Make sure you are within a FirebaseClientProvider.");
    }
    return { app, auth, firestore };
}
export const useFirebaseApp = () => useFirebaseClient().app;
export const useAuth = () => useFirebaseClient().auth;
export const useFirestore = () => useFirebaseClient().firestore;
